import React from "react";
const Header: React.FC<{ logo: string; title: string; status: string }> = (props) => {
    const { logo, title, status } = props;
    return (
        <div className="bg-green-800 flex content-between items-center py-2 px-3 rounded-tr-xl rounded-tl-xl h-20 shadow-md">
            <img width="40" height="40" className="h-10 w-10" src={logo} alt="logo" />
            <div className="flex-col ml-4 m-auto">
                <div className="text-white font-semibold text-lg truncate w-48" title={title}>
                    {title}
                </div>
                <div className="text-sm text-white opacity-80 truncate w-48" title={status}>
                    {status}
                </div>
            </div>
        </div>
    );
};

export default Header;
